import { useMemo } from 'react';

import { BookingStatus, GetBookingQuery, GetSupplierBookingQuery, GetUserBookingQuery } from 'generated/graphql';

const useIsPobPodButtonsDisabled = (booking?: GetBookingQuery['booking'] | GetUserBookingQuery['userBooking'] | GetSupplierBookingQuery['supplierBooking']): boolean => {
    return useMemo(() => !booking?.id || booking?.status === BookingStatus.Waiting, [booking]);
};

export default useIsPobPodButtonsDisabled;